<template>
  <dialog-progress-at
    :showPopup="showPopup"
    :columnKey="'progress_at'"
    :valueMap="valueMap"
    :taskId="taskId"
    @updateValue="onUpdateValue"
  >
  </dialog-progress-at>
</template>

<script>
import DialogProgressAt from "./DialogProgressAt";

export default {
  props: {
    showPopup: { type: Boolean, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    taskId:    { type: String, required: true },
  },
  components: {
    DialogProgressAt,
  },
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    onUpdateValue(taskId, updateKeyValueMap, mode) {
      delete updateKeyValueMap['progress']; // 進捗は変更しない
      mode.push("firstLineAt");
      this.$emit('updateValue', taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
</style>

